import productionConfig from './config.production';

// Preview environment config for the ECS Fargate / Amplify preview stack.
//
// It spreads config.production rather than copying it, deliberately: that file
// contains an Auth0 client_credentials secret, and duplicating it here would put
// a second copy of a live credential in the repo. Only the values that must
// differ for the preview host are overridden.
//
// NOTE: auth.web.redirectURL and logoutURL below must also be registered as
// allowed callback / logout URLs on the Auth0 application, or login on the
// preview host fails. That is an Auth0 console change, not an AWS one.

const previewHost = 'https://aex-hq.preview.in.amazingco.me';

const config = {
  ...productionConfig,

  // The aex API runs the occasions code in production since 2026-10-14, so the
  // UI reads the live API: the Fargate preview API was torn down on 2026-11-01
  // and only this UI remains without a deployed home.
  experienceAPIURL: productionConfig.experienceAPIURL,

  auth: {
    ...productionConfig.auth,
    client: {
      ...productionConfig.auth.client,
      audiences: {
        ...productionConfig.auth.client.audiences,
        // Unchanged on purpose. The preview API is built from production config,
        // so it validates the production audience; changing it here would make
        // every token the UI mints fail verification.
        experienceAPI: productionConfig.auth.client.audiences.experienceAPI,
      },
    },
    web: {
      ...productionConfig.auth.web,
      redirectURL: `${previewHost}/callback`,
      logoutURL: `${previewHost}/logout`,
    },
  },
};

export default config;
